import gql from 'graphql-tag.macro';

export const query = gql`
mutation markMessagesAsRead($selectAll: Boolean, $includedJobs: [ID!]) {
  markMessagesReadByJobs(selectAll: $selectAll, includedJobs: $includedJobs) {
    messages {
      id
      readAt
    }
  }
}
`;

export const markMessagesReadByJobs = {
  query,
};

